import { render } from "./assesszbflowChart.vue?vue&type=template&id=59b2384a"
import script from "./assesszbflowChart.vue?vue&type=script&lang=js"
export * from "./assesszbflowChart.vue?vue&type=script&lang=js"

import "./assesszbflowChart.vue?vue&type=style&index=0&id=59b2384a&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__